import { Component, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UnitActivity } from '@models/imported/SagaSchema/UnitActivity';
import { ListResourceStatus } from '@models/imported/SagaStateLib/ListResourceStatus';
import { AppSettingProviderService, SagaSettingsService } from '@services/settings';
import * as moment from 'moment';
import { Observable, Subject } from 'rxjs';
import { StatusImageService } from '../../services/status-images/status-image.service';
import { StatusTimeService } from '../../services/status-time/status-time.service';

@Component({
  selector: 'app-status-item',
  templateUrl: './status-item.component.html',
  styleUrls: ['./status-item.component.scss']
})
export class StatusItemComponent implements OnInit, OnDestroy {
  @Input()
  status: ListResourceStatus;

  @Input()
  myUnit: UnitActivity;

  @Input()
  horizontal?: boolean;

  @Output()
  get onClick(): Observable<Event> {
    return this._onClick.asObservable();
  }

  get isMyStatus(): boolean {
    return this.myUnit.status.Value === this.status.Value;
  }

  get isAllowed(): boolean {
    return (this.myUnit.status.Children & this.status.Value) !== 0;
  }

  get statusTime(): string {
    return this.statusTimeService.getTime(this.status) || '-';
  }

  useStatusColor: boolean = false;
  statusColor: string = null;

  showIcon: boolean = false;
  statusIcon: string = null;

  statusName: string = null;
  statusNameFontSize: string = null;
  statusTimeFontSize: string = null;

  private darkModeSub = null;

  private readonly _onClick = new Subject<Event>();

  constructor(
    private sagaSettingsService: SagaSettingsService,
    private appSettingsProvider: AppSettingProviderService,
    private statusTimeService: StatusTimeService,
    private statusImages: StatusImageService
  ) {}

  ngOnInit() {
    this.statusName = `Mobile.${this.status.Name}`;

    this.statusNameFontSize = this.sagaSettingsService.getValue('SagaMobileWebClient.StatusNameTextSize');
    this.statusTimeFontSize = this.sagaSettingsService.getValue('SagaMobileWebClient.StatusTimeTextSize');

    this.useStatusColor = this.sagaSettingsService.getValue('SagaMobileWebClient.UseStatusColor');
    if (this.useStatusColor) {
      this.appSettingsProvider.getDarkModeEnabled().subscribe(appSetting => {
        this.darkModeSub = appSetting.$change.subscribe(() => {
          this.statusColor = appSetting.current ? this.status.oColor.toRgbString() : this.status.color.toRgbString();
        });
      });
    }

    this.showIcon = !this.statusImages.isEmpty();
    this.statusIcon = this.statusImages.get(this.status);
  }

  ngOnDestroy() {
    this.darkModeSub?.unsubscribe();
  }

  onStatusClicked($event) {
    if (this.isAllowed) {
      this._onClick.next($event);
      this.statusTimeService.setTime(this.status, moment().toDate());
    }
  }
}
